var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 120,
    viewBox: "0 0 114 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7296 99.1982C9.37251 99.1982 6.2463 102.466 6.2463 107.251C6.2463 112.036 9.37251 115.304 13.7296 115.304C15.1161 115.38 16.5021 115.147 17.7879 114.623C19.0738 114.099 20.2275 113.296 21.1659 112.273L24.1972 115.304C21.9232 118.289 18.2765 119.993 13.4928 119.993C6.00952 119.993 0.799072 114.835 0.799072 107.251C0.799072 99.6249 6.00952 94.4144 13.4928 94.4144C18.0398 94.4144 21.5914 95.882 23.9136 98.5359L20.9292 102.041C19.9953 101.089 18.8717 100.344 17.6314 99.8544C16.3911 99.3647 15.0618 99.1412 13.7296 99.1982Z",
    fill: "#483478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2736 104.119V119.798H48.8265V105.643C48.8265 101.853 46.5524 99.5323 42.7639 99.5323C38.2638 99.5804 35.5642 102.943 35.5642 107.395V119.807H30.1171V84.6607H35.5642V99.5346C37.3647 95.9817 40.5848 94.4192 44.8949 94.4192C50.7688 94.4133 54.2736 98.1093 54.2736 104.119Z",
    fill: "#483478"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7328 109.287H64.6928C65.021 111.101 65.9914 112.736 67.4266 113.893C68.8617 115.05 70.6655 115.652 72.5078 115.588C73.8289 115.602 75.1394 115.35 76.3604 114.845C77.5813 114.34 78.6876 113.594 79.6125 112.65L82.502 115.728C81.1657 117.136 79.546 118.244 77.7498 118.979C75.9536 119.714 74.0218 120.059 72.0823 119.992C64.3141 119.992 59.1987 114.834 59.1987 107.25C59.1987 99.6238 64.456 94.4602 71.9405 94.4133C80.8023 94.4133 84.3975 100.192 83.7328 109.287ZM78.996 105.309C78.8072 101.236 76.1065 98.7715 71.9863 98.7715C70.1507 98.7018 68.3588 99.3423 66.9834 100.56C65.608 101.777 64.7548 103.478 64.6014 105.309H78.996Z",
    fill: "#483478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3656 108.245L95.1035 112.745V119.803H89.6563V84.6607H95.1035V105.877L106.239 94.6032H112.491L103.16 104.361L113.201 119.803H106.754L99.3656 108.245Z",
    fill: "#483478"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7435 37.0824L71.1251 56.1892H81.792L62.0887 31.1135L55.7435 37.0824Z",
    fill: "#483478"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3914 0H75.7212L43.1928 31.1558V7.82911L34.5186 15.3089V51.3714L34.5268 51.3527L42.888 43.3818L88.3914 0Z",
    fill: "#FFB81C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChek);
export default __webpack_public_path__ + "static/media/chek.8be0f4d7ccff9d7077208de498df9d5b.svg";
export { ForwardRef as ReactComponent };